export const doPasswordsMatch = (password: string, confirmPassword: string) => {
    return password === confirmPassword;
  };